import { gql } from '@apollo/client';

import baseFields from '../base';

const FILES = gql`
  fragment Files on File {
   ${baseFields}
    name
    thumbnailPipeFrom
    pipeFrom
    details
    type
    extension
  }
`;

export default FILES;
